var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.5 300V307.5H500H700C751.084 307.5 792.5 348.893 792.5 400C792.5 451.107 751.084 492.5 700 492.5H500H492.5V500V700C492.5 751.107 451.084 792.5 400 792.5C348.916 792.5 307.5 751.107 307.5 700V500V492.5H300H100C48.9159 492.5 7.5 451.107 7.5 400C7.5 348.893 48.9159 307.5 100 307.5H300H307.5V300V100C307.5 48.8934 348.916 7.5 400 7.5C451.084 7.5 492.5 48.8934 492.5 100V300ZM457.5 700V457.5H700C731.752 457.5 757.5 431.632 757.5 400C757.5 368.368 731.752 342.5 700 342.5H457.5V100C457.5 68.3676 431.752 42.5 400 42.5C368.248 42.5 342.5 68.3676 342.5 100V342.5H100C68.2481 342.5 42.5 368.368 42.5 400C42.5 431.632 68.2481 457.5 100 457.5H342.5V700C342.5 731.632 368.248 757.5 400 757.5C431.752 757.5 457.5 731.632 457.5 700Z",
    fill: "#FFD700",
    fillOpacity: 0.2,
    stroke: "#FFD700",
    strokeWidth: 15,
    strokeDasharray: "0,0,0,5485.03125"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "2s",
    values: "0,0,0,5485.03125;            0,2742.515625,2742.515625,0;            5485.03125,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2e9d44ad5f6efc30591578c4f0d0b915.svg";
export { ForwardRef as ReactComponent };